import { createFileRoute, Link } from "@tanstack/react-router";
import { useState, useMemo } from "react";
import { ChevronLeft } from "lucide-react";
import { PageHeader } from "@/components/app-shell";
import { CalcShell, Field, NumberInput, ResultCard, fmt } from "@/components/calculators/CalcShell";
import { AddToQuoteButton } from "@/components/calculators/AddToQuoteButton";
import { linesFromLekter } from "@/components/calculators/lineMappers";
import { lekterCalc } from "@/domain/calculators/carpenter";

export const Route = createFileRoute("/_authenticated/calculations/carpenter/lekter")({
  component: LekterPage,
});

function LekterPage() {
  const [area, setArea] = useState<number | "">("");
  const [lektCc, setLektCc] = useState<number | "">(350);
  const [sloyfeCc, setSloyfeCc] = useState<number | "">(600);

  const r = useMemo(() => {
    if (area === "" || lektCc === "") return null;
    return lekterCalc({
      takflate_m2: Number(area),
      lekt_cc_mm: Number(lektCc),
      sloyfe_cc_mm: sloyfeCc === "" ? undefined : Number(sloyfeCc),
    });
  }, [area, lektCc, sloyfeCc]);

  return (
    <>
      <Link to="/calculations" className="mb-4 inline-flex items-center text-sm text-muted-foreground hover:text-foreground">
        <ChevronLeft className="h-4 w-4" /> Beregninger
      </Link>
      <PageHeader title="Lekter og sløyfer" subtitle="Beregn løpemeter for taklekter og sløyfer." />
      <CalcShell
        title="Inndata"
        result={r ? (
          <>
            <ResultCard
            title="Materialbehov"
            rows={[
              { label: "Lekter",  value: `${fmt(r.lekt_lm, 1)} m`, strong: true },
              { label: "Sløyfer", value: `${fmt(r.sloyfe_lm, 1)} m` },
            ]}
            note="c/c lekter velges etter takstein/plate. Vanlig 320–380 mm for takstein."
          />
            <div className="mt-3 flex justify-end">
              <AddToQuoteButton sourceLabel={`Lekter og sløyfer`} lines={linesFromLekter(r)} defaultLaborHours={Math.max(0, Math.round(((r.lekt_lm + r.sloyfe_lm) * 0.05) * 10) / 10)} />
            </div>
          </>
        ) : <div className="card p-5 text-sm text-muted-foreground">Fyll inn takflate.</div>}
      >
        <Field label="Takflate" unit="m²"><NumberInput value={area} onChange={setArea} /></Field>
        <Field label="c/c lekter" unit="mm"><NumberInput value={lektCc} onChange={setLektCc} /></Field>
        <Field label="c/c sløyfer" unit="mm"><NumberInput value={sloyfeCc} onChange={setSloyfeCc} /></Field>
      </CalcShell>
    </>
  );
}
